import { PermissionEnum, ProjectInstallationStatusEnum, ProjectStatusEnum } from '@api/enum';
import NotificationBadge from '@components/NotificationBadge/NotificationBadge';
import useAuthPermission from '@hooks/use-auth-permission';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import { Tooltip } from '@library/tooltip';
import { useProjectInstallationListData } from 'modules/project-installation/hooks/useProjectInstallationListData';
import moment from 'moment';
import { Link, useNavigate, useParams } from 'react-router-dom';

const ProjectInstallationList = () => {
    const { clientInstallationId } = useParams();
    const { projectInstallationList, isLoading } = useProjectInstallationListData(clientInstallationId);
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();

    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover
            isLoading={isLoading}
            data={projectInstallationList}
            columns={[
                {
                    header: 'ID',
                },
                {
                    header: 'Project Name',
                },
                {
                    header: 'Created At',
                },
                {
                    header: 'Created BY',
                },
                {
                    header: 'Status',
                },
                // {
                //     header: 'Edit',
                // },
            ]}
            renderRow={(row) => (
                <Table.Row
                    key={row._id}
                    onClick={() => {
                        hasPermission(PermissionEnum.CLIENT_INSTALLATION_UPDATE)
                            ? navigate(
                                  `/client-installations/${clientInstallationId}/project-installations/${row._id}/details`
                              )
                            : null;
                    }}
                >
                    <Table.Cell>
                        {
                            <div className="text-primary">
                                <Link
                                    to={`/client-installations/${clientInstallationId}/project-installations/${row._id}/details`}
                                >
                                    {row._id}
                                </Link>
                            </div>
                        }
                    </Table.Cell>
                    <Table.Cell>
                        <div className="flex items-center ">
                            {row?.name}

                            {row?.siteRecceCount !== 0 && (
                                <Tooltip placement="right" content={`Total Site Recce:${row?.siteRecceCount}`}>
                                    <NotificationBadge count={row?.siteRecceCount} />
                                </Tooltip>
                            )}
                        </div>
                    </Table.Cell>

                    <Table.Cell>{moment(row?.createdAt, 'YYYYMMDD').format('DD MMM, YYYY')}</Table.Cell>
                    <Table.Cell>{row?.createdBy?.name || '-'}</Table.Cell>
                    <Table.Cell>
                        {' '}
                        <Chip
                            label={row.status}
                            color={row.status === ProjectInstallationStatusEnum.APPROVED ? 'success' : 'warning'}
                            variant="shaded"
                        />
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default ProjectInstallationList;
